export default abstract class CreateUpdateModel {
  created?: Date
  updated?: Date
}
